import $ from 'jquery';

// Scripts to handle Opayo methods ...
$(document).ready(function($) {
    $(function () {

        initMerchantSessionKey();

        initOpayoPaymentForm();

    });


    var merchantSessionKey = null;
    var merchantSessionKeyExpiry = null;

    //var merchantSessionKeyRemaining = null;

    function initMerchantSessionKey() {

        //setMerchantSessionKey();

    }


    function setMerchantSessionKey() {

        // Check if we already have a valid merchant session key
        if (merchantSessionKey) {
            if (now() < merchantSessionKeyExpiry) {
                // Current key is valid
                return true;
            }
        }

        merchantSessionKey = null;
        merchantSessionKeyExpiry = null;

        // If we are still here need to run the AJAX request to get a new key
        return axios.get('/manager/ecommerce/payment-gateways/opayo/get-merchant-session-key')
            .then(function (response) {

                //console.log(response)
                if (response) {
                    merchantSessionKey = response.merchantSessionKey;
                    merchantSessionKeyExpiry = getTime() + response.remaining;
                }
                //console.log(merchantSessionKey, merchantSessionKeyExpiry);

            })
            .catch(function (error) {
                console.log(error);
            });

    }


    function initOpayoPaymentForm() {

        if ($('#browser-data').length) {

            let tz = (new Date()).getTimezoneOffset();

            // Collect browser data and push it to the form
            const browserData = {
                browserJavaEnabled: window.navigator.javaEnabled(),
                browserLanguage: window.navigator.language,
                browserColorDepth: window.screen.colorDepth,
                browserScreenHeight: window.screen.availHeight,
                browserScreenWidth: window.screen.availWidth,
                browserTZ: tz,
                browserUserAgent: window.navigator.userAgent
            };

            $('#browser-data').val(JSON.stringify(browserData));

            // const browserData = window.navigator;
            // browserData.browserJavaEnabled = window.navigator.javaEnabled();

            //console.log(browserData);

        }

        $('#opayo-payment-form-submit').unbind('click');
        $('#opayo-payment-form-submit').on('click', function (e) {

            // Check if we have a current MerchantSessionKey
            //setMerchantSessionKey();

            // Prevent multiple submissions
            //let $submit = $(this).find('#opayo-payment-form-submit');
            $(this).html('Processing <i class="fa-solid fa-spinner fa-spin"></i>');
            $(this).attr('disabled', true);

            // Prevent initial form submission
            e.preventDefault();

            let merchantSessionKey = $('#merchant-session-key').val();

            let cardName = $('#opayo-cardholder-name').val();
            let cardNumber = $('#opayo-card-number').val().replace(/\s+/g, '');
            let expiryDate = $('#opayo-expiry-month').val() + $('#opayo-expiry-year').val();
            let securityCode = $('#opayo-security-code').val();

            //console.log(merchantSessionKey, cardName, cardNumber, expiryDate, securityCode);

            sagepayOwnForm({
                merchantSessionKey: merchantSessionKey
            }).tokeniseCardDetails({
                cardDetails: {
                    cardholderName: cardName,
                    cardNumber: cardNumber,
                    expiryDate: expiryDate,
                    securityCode: securityCode
                },
                onTokenised: function (result) {
                    if (result.success) {
                        //console.log(result);
                        $('#card-identifier').val(result.cardIdentifier);
                        $('#opayo-payment-form').submit();
                    } else {
                        // Some more sophisticated error handling needed here ...
                        let modalContent = [];
                        if (Array.isArray(result.errors)) {
                            result.errors.forEach(function (error) {
                                modalContent.push(error.message);
                            });
                        }
                        showConfirmModal('', 'Card error', modalContent.join('<br>'), [{
                            text: 'Close',
                            click: 'closeModal();',
                            icon: ''
                        }]);
                        //console.log(result);
                    }
                }
            });

        });

    }
});
